export default __webpack_public_path__ + "static/media/Staunchguard Plate Boots.0dcfd2d7.jpg";